/**
 * 	礼品卡核销
 */
export default [
    {
      path: '/writeoffCard',
      component: () => import('@/views/writeoffCard/Index.vue'),
      meta: { requiresAuth: true, title: '礼品卡核销', icon: '', role: true },
      children:
        [
          {
            path: '',
            component: () => import('@/views/writeoffCard/search.vue'),
            meta: { title: '礼品卡核销', role: true },
          },
          {
            path: 'cardList',
            component: () => import('@/views/writeoffCard/cardList.vue'),
            meta: { title: '礼品卡核销', role: true },
          },
          {
            path: 'confirm',
            component: () => import('@/views/writeoffCard/confirm.vue'),
            meta: { title: '礼品卡核销', role: true },
          },
          {
            path: 'writeoffList',
            component: () => import('@/views/writeoffCard/cardWriteoffList.vue'),
            meta: { title: '礼品卡核销', role: true },
          },
          {
            path: 'sureRetreat',
            component: () => import('@/views/retreatCoupon/sureRetreat.vue'),
            meta: { title: '礼品卡核销', role: true },
          },
          {
            path: 'success',
            component: () => import('@/views/writeoffCard/success.vue'),
            meta: { title: '礼品卡核销', role: true },
          },
        ],
    },

    {
      path: '/resetCard',
      component: () => import('@/views/writeoffCard/returnWriteOff.vue'),
      meta: { requiresAuth: true, title: '礼品卡核销', icon: '', role: true },
      children:
        [
          {
            path: '',
            component: () => import('@/views/writeoffCard/returnSearch.vue'),
            meta: { title: '核销列表', role: true },
          },
          {
            path: 'returnList',
            component: () => import('@/views/writeoffCard/returnList.vue'),
            meta: { title: '核销详情', role: true },
          },
          {
            path: 'success',
            component: () => import('@/views/writeoffCard/returnSuccess.vue'),
            meta: { title: '核销详情', role: true },
          },
        ],
    },
    {
      path: '/writeoffLog',
      component: () => import('@/views/coupon/Index.vue'),
      meta: { requiresAuth: true, title: '礼品卡核销', icon: '', role: true },
      children:
        [
          {
            path: '',
            component: () => import('@/views/writeoffCard/cardWriteoffList.vue'),
            meta: { title: '核销列表', role: true },
          },
          {
            path: 'detail',
            component: () => import('@/views/writeoffCard/cardWriteoffDetail.vue'),
            meta: { title: '核销详情', role: true },
          },
        ],
    },
  ];